import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';

import {
  CHART_AGGREGATES,
  CHART_BUCKETS,
  CHART_TYPES,
  chartKeyFromName,
  chartableXFields,
  chartableYFields,
  isDateField,
} from '../../report/report-chart/report-chart-config';

/**
 * One chart configuration row in the Report Editor's Charts tab. Edits the
 * config object in place; the parent owns the array (add/remove/move).
 */
@Component({
  selector: 'app-chart-editor',
  templateUrl: './chart-editor.component.html',
  styleUrls: ['./chart-editor.component.scss']
})
export class ChartEditorComponent implements OnChanges {

  @Input() chart: any;
  @Input() fields: any[] = [];
  @Input() index = 0;
  @Input() count = 0;
  @Output() remove = new EventEmitter<void>();
  @Output() moveUp = new EventEmitter<void>();
  @Output() moveDown = new EventEmitter<void>();

  chartTypes = CHART_TYPES;
  aggregates = CHART_AGGREGATES;
  buckets = CHART_BUCKETS;

  xFields: any[] = [];
  yFields: any[] = [];
  seriesFields: any[] = [];
  keyEdited = false;

  ngOnChanges(): void {
    this.xFields = chartableXFields(this.fields);
    this.yFields = chartableYFields(this.fields);
    this.seriesFields = (this.fields || []).filter(f => f && f.path && !isDateField(f) && this.yFields.indexOf(f) === -1);
    if (this.chart) {
      this.chart.yPaths = Array.isArray(this.chart.yPaths) ? this.chart.yPaths : [];
      this.keyEdited = !!this.chart.key && this.chart.key !== chartKeyFromName(this.chart.name);
    }
  }

  get xIsDate(): boolean {
    const field = (this.fields || []).find(f => f && f.path === this.chart.xPath);
    return isDateField(field);
  }

  // The key follows the name until it has been edited by hand.
  nameChanged() {
    if (!this.keyEdited) {
      this.chart.key = chartKeyFromName(this.chart.name);
    }
  }

  keyChanged() {
    this.keyEdited = !!this.chart.key;
  }

  isDefaultY(path: string): boolean {
    return this.chart.yPaths.indexOf(path) !== -1;
  }

  toggleDefaultY(path: string, on: boolean) {
    const at = this.chart.yPaths.indexOf(path);
    if (on && at === -1) {
      this.chart.yPaths.push(path);
    } else if (!on && at !== -1) {
      this.chart.yPaths.splice(at, 1);
    }
  }
}
